// The brief transition presents mounting guidance, not an external lookup.
class CarplayCompatibilityChecker extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.purchaseBlock = this.closest('.buy-buttons-block--carplay');
    this.modelInput = this.querySelector('[data-motorcycle]');
    this.resultShell = this.querySelector('[data-result-shell]');
    this.verifyButton = this.querySelector('[data-verify]');
    this.querySelector('[data-fit-form]').addEventListener('submit', this.verify, { signal });
    this.modelInput.addEventListener('input', this.resetResult, { signal });
    this.addEventListener('click', this.onClick, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    clearTimeout(this.analysisTimer);
  }

  resetResult = () => {
    clearTimeout(this.analysisTimer);
    this.setChecking(false);
    this.modelInput.setCustomValidity('');
    this.resultShell.hidden = true;
    this.removeAttribute('data-has-result');
  };

  setChecking(checking) {
    this.checking = checking;
    this.verifyButton.disabled = checking;
    this.modelInput.readOnly = checking;
    this.querySelector('[data-verify-label]').style.visibility = checking ? 'hidden' : '';
    this.querySelector('[data-loading]').hidden = !checking;
    this.querySelector('[data-analysis-status]').textContent = checking ? 'Analyse de votre configuration…' : '';
    this.resultShell.setAttribute('aria-busy', String(checking));
  }

  verify = (event) => {
    event.preventDefault();
    if (this.checking) return;
    if (!this.modelInput.value.trim()) {
      this.modelInput.setCustomValidity('Indiquez la marque, le modèle et l’année de votre moto.');
      this.modelInput.reportValidity();
      return;
    }
    const motorcycle = this.modelInput.value.trim();
    const isBmwSearch = /(^|[^a-z])bmw([^a-z]|$)/i.test(motorcycle);
    const isBmwProduct = this.dataset.mountFamily === 'bmw';
    this.setChecking(true);
    this.querySelector('[data-result-title]').textContent = isBmwSearch
      ? 'Nous avons des écrans mieux adaptés à votre BMW'
      : isBmwProduct
        ? 'Montage à confirmer'
        : 'Installation possible avec le support universel fourni';
    this.querySelector('[data-result-description]').textContent = isBmwSearch
      ? 'Découvrez notre sélection pour les motos équipées d’un support BMW Navigator.'
      : isBmwProduct
        ? 'Cet écran est prévu pour une BMW avec support Navigator. Demandez-nous conseil pour votre moto.'
        : 'Votre moto doit disposer d’un emplacement adapté sur le guidon.';
    this.querySelector('[data-result-icon]').hidden = isBmwSearch || isBmwProduct;
    this.querySelector('[data-result-link]').hidden = !isBmwSearch;
    this.setAttribute('data-has-result', '');
    this.resultShell.hidden = false;
    this.analysisTimer = setTimeout(() => { this.setChecking(false); }, 1000);
  };

  onClick = async (event) => {
    if (event.target.closest('[data-fit-contact]')) {
      await customElements.whenDefined('carplay-purchase-help');
      if (!this.isConnected) return;
      const help = this.purchaseBlock?.querySelector('carplay-purchase-help');
      if (!help) return;
      help.openPopup(true);
      help.querySelector('[data-reason="Compatibilité avec ma moto"]')?.click();
    }
  };
}

if (!customElements.get('carplay-compatibility-checker')) {
  customElements.define('carplay-compatibility-checker', CarplayCompatibilityChecker);
}
